module.exports = __webpack_public_path__ + "static/media/uoa-1.9be5c849.jpg";